<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'view', 'pause', 'resume', 'cancel']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleView = campaign => emit('view', campaign);
const handlePause = campaign => emit('pause', campaign);
const handleResume = campaign => emit('resume', campaign);
const handleCancel = campaign => emit('cancel', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :trigger-rules="campaign.trigger_rules"
      :template-params="campaign.template_params"
      :is-live-chat-type="isLiveChatType"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @view="handleView(campaign)"
      @pause="handlePause(campaign)"
      @resume="handleResume(campaign)"
      @cancel="handleCancel(campaign)"
    />
  </div>
</template>
